import { useEffect, useRef } from "react"
import io from "socket.io-client"
import { useStore } from "../store"
// import { usePOIStore } from "./activePOIStore"

const FilterBroadcaster = () => {
  const socket = useRef()
  const url = process.env.REACT_APP_MARKETING_SUITE
  const role = process.env.REACT_APP_ROLE

  const bedroomCounts = useStore(state => state.bedroomCounts)
  const setBedroomCounts = useStore(state => state.setBedroomCounts)

  const bathroomCounts = useStore(state => state.bathroomCounts)
  const setBathroomCounts = useStore(state => state.setBathroomCounts)

  const aspects = useStore(state => state.aspects)
  const setAspects = useStore(state => state.setAspects)

  const state = {
    bedroomCounts: bedroomCounts,
    bathroomCounts: bathroomCounts,
    aspects: aspects
  }

  useEffect(() => {
    socket.current = io(url)
    socket.current.emit("subscribe-filterzustand", 1000)
    if (role === "recipient") {
      socket.current.on("filterzustand", actAptZustand => {
        setBedroomCounts(actAptZustand.bedroomCounts)
        setBathroomCounts(actAptZustand.bathroomCounts)
        setAspects(actAptZustand.aspects)
      })
    }
    return () => socket.current.close()
  }, [state, role, url])

  useEffect(() => {
    if (role === "sender") {
      socket.current.emit("filterzustand", state)
    }
  }, [state, role, url])

  return null
}

FilterBroadcaster.propTypes = {}

export default FilterBroadcaster
